import type { ReactNode } from 'react';
import Chip from '../Fundamentals/Chip/Chip';
import { firstNonEmptyString } from '../../Utils/stringUtils';
import type { FilterOption } from './PriceSimulation.types';

interface FilterCardProps {
    children?: ReactNode;
    selectedItems?: FilterOption[];
    onRemoveItem?: (item: FilterOption) => void;
    maxVisibleItems?: number;
    renderCustomBody?: (() => ReactNode) | null;
}

const FilterCard = ({ children, selectedItems = [], onRemoveItem, maxVisibleItems = 6, renderCustomBody = null }: FilterCardProps) => {
    const shouldScroll = selectedItems.length > maxVisibleItems;
    const minSlots = 3;
    const ghostCount = Math.max(0, minSlots - selectedItems.length);

    return (
        <div className="filter-card border rounded-8 p-16 d-flex flex-column">
            <div className="mb-12">{children}</div>

            <div className={`filter-card-body d-flex flex-column overflow-y-auto${shouldScroll ? ' scrollable' : ''}`}>
                {renderCustomBody ? (
                    renderCustomBody()
                ) : (
                    <div className="d-flex flex-column gap-8 w-100">
                        {selectedItems.map((item) => (
                            <Chip key={item.id} label={firstNonEmptyString(item.name, item.label)} onRemove={() => onRemoveItem?.(item)} />
                        ))}

                        {Array.from({ length: ghostCount }).map((_, index) => (
                            <div key={`ghost-${index}`} className="filter-card-ghost-pill"></div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default FilterCard;
